/* eslint-disable i18next/no-literal-string */
import s from '@components/AddToCartPopup/AddToCartPopup.module.scss'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import { useRouter } from 'next/router'
import { ProductItem } from '@components/common/ProductTile/ProductTile'
import { AlfaRichContent as RichContent } from '@components/alfakher/pylot-rich-content'
import React, { useEffect, useRef, useState } from 'react'
import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { getCMSBlocks } from '@pylot-data/hooks/cms/graphql/getCMSBlocks'
import { CmsBlocks } from '@pylot-data/fwrdschema'
import { useTranslation } from 'next-i18next'
import { Button } from '@corratech/pylot-ui'
import cn from 'classnames'
import { X as Cross } from 'react-feather'
import Image from '@corratech/pylot-image'
import { AddToCartSucess } from '@components/icons/AddToCartSucess'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

type CmsBlockType = {
    [key: string]: {
        content: string
    }
}
export const AddToCartPopup = () => {
    const [cmsBlockContent, setcmsBlockContent] = useState<CmsBlockType>({})
    const ref = useRef() as React.MutableRefObject<HTMLDivElement>
    const router = useRouter()
    const { t } = useTranslation(['common'])

    const {
        // @ts-ignore
        setAddToCartPopupPayload,
        // @ts-ignore
        addToCartPopupPayload
    } = useAlfakherContext()

    const { locale } = useRouter()

    useEffect(() => {
        setAddToCartPopupPayload({
            ...addToCartPopupPayload,
            isShowPopup: false
        })
    }, [router.asPath])
    async function getCmsBlockContent() {
        if (
            addToCartPopupPayload &&
            addToCartPopupPayload.cmsBlockId &&
            // if block exist , don't fetch the block
            !(addToCartPopupPayload?.cmsBlockId in cmsBlockContent)
        ) {
            const cmsPageData = await graphqlFetch<
                { identifiers: string[] },
                { cmsBlocks: CmsBlocks }
            >({
                query: getCMSBlocks,
                variables: {
                    identifiers: [addToCartPopupPayload.cmsBlockId]
                },
                locale
            })
            if (cmsPageData?.data?.cmsBlocks?.items) {
                // save cms contents in the state whithout removing the other block
                setcmsBlockContent({
                    ...cmsBlockContent,
                    [addToCartPopupPayload.cmsBlockId]:
                        cmsPageData?.data?.cmsBlocks?.items[0]
                })
            }
        }
    }

    useEffect(() => {
        getCmsBlockContent()
        if (addToCartPopupPayload?.isShowPopup) {
            disableBodyScroll(ref.current)
        } else {
            enableBodyScroll(ref.current)
        }
    }, [addToCartPopupPayload])

    return (
        <div
            className={cn(
                s.AddToCartPopup,
                addToCartPopupPayload?.isShowPopup ? s.AddToCartPopup_show : ''
            )}
            ref={ref}
        >
            <div className={cn(s['modal-content'], 'modal-content')}>
                <Button
                    variant="link"
                    onClick={() =>
                        setAddToCartPopupPayload({
                            ...addToCartPopupPayload,
                            isShowPopup: false
                        })
                    }
                    aria-label={t('Close panel')}
                    className={cn(s['close-panel'], 'close-panel')}
                >
                    <Cross />
                </Button>
                <div className={cn(s['modal-body'], 'modal-body')}>
                    {addToCartPopupPayload?.product && (
                        <div className={cn('addToCartToastWithButtons')}>
                            <div className={cn('addToCartToast')}>
                                <Image
                                    src={addToCartPopupPayload?.product.image}
                                    alt={addToCartPopupPayload?.product.name}
                                    width={80}
                                    height={80}
                                />
                                <AddToCartSucess />
                                <div>
                                    {addToCartPopupPayload?.product.isMultiple
                                        ? t('Selected product(s) added to cart')
                                        : t('cart|{{name}} was added to cart', {
                                              name:
                                                  addToCartPopupPayload?.product
                                                      .name
                                          })}
                                </div>
                            </div>
                            <div className="AddToCartPopupButtons flex-wrap">
                                <div className="AddToCartPopupButton mr-2">
                                    <Button
                                        data-variant="secondary"
                                        aria-label="secondary"
                                        className={cn(
                                            'btn-secondary',
                                            'continueShoppingPopup'
                                        )}
                                        onClick={() => {
                                            setAddToCartPopupPayload({
                                                ...addToCartPopupPayload,
                                                isShowPopup: false
                                            })
                                        }}
                                    >
                                        <span>
                                            {t('cart|Continue Shopping')}
                                        </span>
                                    </Button>
                                </div>
                                <div className="AddToCartPopupButton">
                                    <Button
                                        data-variant="primary"
                                        aria-label="primary"
                                        className={cn(
                                            'btn-primary',
                                            'goToCheckoutPopup'
                                        )}
                                        onClick={() => {
                                            setAddToCartPopupPayload({
                                                ...addToCartPopupPayload,
                                                isShowPopup: false
                                            })
                                            router.push('/checkout')
                                        }}
                                    >
                                        <span>{t('cart|Go to Checkout')}</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                    {addToCartPopupPayload?.cmsBlockId &&
                        !addToCartPopupPayload?.hideContent && (
                            <RichContent
                                html={
                                    cmsBlockContent[
                                        addToCartPopupPayload.cmsBlockId
                                    ]?.content
                                }
                                ProductTile={ProductItem}
                            />
                        )}
                </div>
            </div>
        </div>
    )
}
